export default interface SupportSheetModel {
    id: string,
    ownerBrokerPrincipleId: string,
    chartererBrokerPrincipleId: string,
    ownerBrokerPrincipleName: string,
    chartererBrokerPrincipleName: string,

    lay: string,//Date
    can: string,//Date
    brokerReminder: boolean,

    //VOY, COA
    cargoAndQuantity: string,
    freightRate: string,

    loadportInfo: string,//string only
    disportInfo: string,//string only
    loadDisrate: string,
    demDetention: string,


    //TCT, TC
    hireRate: string,//Date
    hire: string,
    delivery: string,
    redelivery: string,
    range: string,
    ilohcandCve: string,
    minMaxPeriodTill: string,//Date

    paymentNote: string,

    status: SupportSheetStatus,//SupportSheetStatus
    note: string,
    analysis: string,//json of SupportSheetAnalysisModel 

    checkLists: string,//json of CheckLists

    //pre-voyage
    //VOY
    quantity: number | null,
    loadportAgentType: string,//Owners or Chtrs
    loadport: number | null,//PortModel
    loadportAgent: string | null,//AgentModel
    disportAgentType: string,//Owners or Chtrs
    disport: number | null,//PortModel
    disportAgent: string | null,//AgentModel
    isSendDraftToFN: boolean,
    //TCT, TC
    onhireBunkerPort: number | null, //PortModel
    onhireBunkerSurveyorCompany: string | null,//SurveyorModel
    onhireBunkerSurveyorDetailAndCost: string,
    offhireBunkerPort: number | null, //PortModel
    offhireBunkerSurveyorCompany: string | null,//SurveyorModel
    offhireBunkerSurveyorDetailAndCost: string,

    //on voyage
    dischargeCargoAtDisport: number | null,//PortModel
    whichDocument: string,
    obtainVesselContactDetails: string | null,

    //VOY
    timesheets: string, //json of SupportSheetTimesheetModel[]
    //TCT, TC
    hirePaymentStatus: string, //json of SupportSheetHirePaymentStausModel
    hirePayment: number,

    //post voyage
    //VOY
    demDesAtPorts: string, //json of SupportSheetDemDesAtPortModel[]
    dispute: string,
    obtainInvoiceFrom: string,//Owners or Chtrs
    sendTo: string,//Owners or Chtrs
    sendBankSlipTo: string,//Owners or Chtrs
    receivedPayment: string,//Owners or Chtrs

    //TCT,TC
    chartererFhs: number,
    ownerFhs: number,
    ifAny: string,
    afterBothSidesConfirms: string,//Owners or Chtrs
    sendFinalHireInvoice: string,//Owners or Chtrs
    obtainBankSlipFromFirst: string,//Owners or Chtrs
    obtainBankSlipFromSecond: string,//Owners or Chtrs

    collectCommFrom: string,//Owners or Chtrs
    invoices: string, //json of SupportSheetInvoiceModel[]
    invoiceTotal: string,
    invoiceOurs: string,
    invoiceCoBrk: string,
    commTerm: string,
}

export enum SupportSheetStatus {
    PreArrivalLoadPort = "PRE-ARRIVAL LOADPORT",
    OnVoyage = "ON-VOYAGE",
    PendingLayTimeLTC = "PENDING LAYTIME LTC",
    PendingCommission = "PENDING COMMISSION",
    CloseFile = "CLOSED FILE",
    Cancel = "CANCEL",
    PendingDisputes = "PENDING DISPUTES",

    //TCT
    PreDelivery = "PRE-DELIVERY",
    Delivered = "DELIVERED",
    PendingFhs = "PENDING FHS",

    //Unknown
    Blank = "BLANK"
}

export interface CheckList {
    checkListItems: string[],
    history: CheckListHistoryItem[]
}

export interface CheckListHistoryItem {
    name: string,//name of SupportSheetCheckListConstant
    date: string//iso string date
}